import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faMinus } from "@fortawesome/free-solid-svg-icons"

export const Minus = (props) => {
  return <FontAwesomeIcon faIcon={faMinus} {...props} />
}
